export function FormField({
    legend,
    value,
    error,
    onChange,
    ...props
}: {
    legend: string;
    value: string;
    error: string | undefined;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange">) {
    return (
        <fieldset className="fieldset mb-0">
            <legend className="fieldset-legend text-xs font-medium text-gray-600">
                {legend}
            </legend>
            <div className="relative">
                <input
                    className="input input-bordered input-sm w-full pl-3 pr-8"
                    value={value}
                    onChange={onChange}
                    {...props}
                />
            </div>
            <p className="text-red-600 text-xs">{error}</p>
        </fieldset>
    );
}
